import React, { useState, useEffect } from 'react';
import { Card, ListGroup, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import ProjectCodesServices from '../../../../services/ProjectCodeService';

const ViewProjectCode = () => {
  const { id } = useParams(); // Get the project code ID from URL params
  const navigate = useNavigate();
  const [projectCode, setProjectCode] = useState(null);

  // Fetch project code data
  useEffect(() => {
    const fetchProjectCode = async () => {
      try {
        const data = await ProjectCodesServices.view(id);
        setProjectCode(data.data);
      } catch (error) {
        console.error('Error fetching project code:', error);
      }
    };
    fetchProjectCode();
  }, [id]);



  if (!projectCode) {
    return <div>Loading...</div>; // Show a loading state while fetching
  }

  return (
    <div>
      <h2>View Project Code</h2>
      <Card>
        <Card.Header as="h5">Project Code Details</Card.Header>
        <Card.Body>
          <ListGroup variant="flush">
            <ListGroup.Item><strong>ID:</strong> {projectCode._id}</ListGroup.Item>
            <ListGroup.Item><strong>Employee ID:</strong> {projectCode.employeeId}</ListGroup.Item>
            <ListGroup.Item><strong>Full Name:</strong> {projectCode.fullName}</ListGroup.Item>
            <ListGroup.Item>
              <strong>Project Codes:</strong>
              <ul>
                {projectCode.projectCodes.map((code, index) => (
                  <li key={index}>{code}</li>
                ))}
              </ul>
            </ListGroup.Item>
            <ListGroup.Item><strong>Created At:</strong> {new Date(projectCode.createdAt).toLocaleString()}</ListGroup.Item>
            <ListGroup.Item><strong>Updated At:</strong> {new Date(projectCode.updatedAt).toLocaleString()}</ListGroup.Item>
          </ListGroup>
         
        </Card.Body>
      </Card>
    </div>
  );
};

export default ViewProjectCode;
